import { createStart, createMiddleware } from "@tanstack/react-start";

import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";
import { isLegacyHost, isLegacyPathOnPrimary } from "./lib/blog/legacy-redirects";
import { renderErrorPage } from "./lib/error-page";
import { productRedirect } from "./lib/checkout/product-redirects";

/**
 * Domínio antigo do blog (e-fisio.wiki.br): tudo responde 301 permanente
 * para o destino equivalente em fisioemortopedia.com.br/e-fisio.
 */
const legacyDomainMiddleware = createMiddleware().server(async ({ next, request }) => {
  const productLocation = productRedirect(request.url, request.headers.get("host"));
  if (productLocation && (request.method === "GET" || request.method === "HEAD")) {
    return new Response(null, { status: 301, headers: { Location: productLocation } });
  }
  if (isLegacyHost(request.headers.get("host"))) {
    const { buildLegacyRedirectResponse } = await import(
      "./lib/blog/legacy-redirects.server"
    );
    return buildLegacyRedirectResponse(request);
  }
  // Caminhos do WordPress chegando no domínio principal (ex.: quando o domínio
  // antigo é redirecionado para o primário mantendo o caminho).
  const path = new URL(request.url).pathname;
  if (isLegacyPathOnPrimary(path)) {
    const { buildLegacyRedirectResponse } = await import(
      "./lib/blog/legacy-redirects.server"
    );
    return buildLegacyRedirectResponse(request);
  }
  return next();
});

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  requestMiddleware: [legacyDomainMiddleware, errorMiddleware],
  functionMiddleware: [attachSupabaseAuth],
}));
